import { render, staticRenderFns } from "./InfoTop.vue?vue&type=template&id=32c675a6&scoped=true"
import script from "./InfoTop.vue?vue&type=script&lang=js"
export * from "./InfoTop.vue?vue&type=script&lang=js"
import style0 from "./InfoTop.vue?vue&type=style&index=0&id=32c675a6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c675a6",
  null
  
)

export default component.exports